<div [formGroup]="group">

  <app-formelementinputlabel [config]="config" [group]="group"></app-formelementinputlabel>

  <app-date-picker [config]="config" [group]="group" [formControlName]="config.name" #formInput></app-date-picker>

  <app-formelementinputdescription [config]="config" [group]="group"></app-formelementinputdescription>
  <app-formelementinput-validationmessages [config]="config" [group]="group"></app-formelementinput-validationmessages>
</div>
